import "./LocalSeoConsultantYork.module.css";
import Header from "@/reusable_sections/Header";
import Editorial from "./sections/Editorial";
import Casestudies from "./sections/Casestudies";
import Consultantvsagency from "./sections/Consultantvsagency";
import Sectors from "./sections/Sectors";
import Localhero from "./sections/Localhero";
import Consultation from "./sections/Consultation";
import YorkIntelligence from "./sections/YorkIntelligence";
import Process from "./sections/Process";
import YorkFaq from "./sections/YorkFaq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantYorkPage() {
  return <div>
      <Header />
      <Editorial />
      <Casestudies />
      <Consultantvsagency />
      <Sectors />
      <Localhero />
      <Consultation />
      <YorkIntelligence />
      <Process />
      <YorkFaq />
      <Services />
      <Footer />
    </div>;
}